import {
  isDtcCryptoLoan,
  toLtvPercentage,
} from 'containers/pages/Dashboard/utils/cryptoUtils';
import { getQuickpayLoanSetupThresholds } from './cryptoUtils';

export function parseAutopayIntent(search) {
  const raw = new URLSearchParams(search || '').get('intent');
  if (!raw) return false;
  const v = String(raw).toLowerCase();
  return v === 'autopay' || v === 'enroll-autopay' || v === 'enroll_autopay';
}

export function resolveQuickpayLandingTarget({
  fromPathname,
  accounts,
  isApplePayAvailable,
  intentAutopay,
  autopaysPayload,
}) {
  const list = Array.isArray(accounts) ? accounts : [];
  const hasPayPath = list.length > 0 || isApplePayAvailable;
  const autopays = Array.isArray(autopaysPayload) ? autopaysPayload : [];
  const hasExistingAutopay = autopays.length > 0;
  const enrollEligible = intentAutopay && !hasExistingAutopay;

  let goToUrl = '/quickpay/add-payment-method';

  if (fromPathname) {
    goToUrl = fromPathname;
  } else if (hasPayPath) {
    goToUrl = enrollEligible ? '/quickpay/enroll-autopay' : '/quickpay/simple-pay';
  }

  if (goToUrl === '/quickpay/add-payment-method' && hasPayPath) {
    goToUrl = enrollEligible ? '/quickpay/enroll-autopay' : '/quickpay/simple-pay';
  }

  const navigateState = {};
  if (goToUrl === '/quickpay/add-payment-method' && intentAutopay) {
    navigateState.afterAddPaymentMethod = '/quickpay/enroll-autopay';
  }

  return { goToUrl, navigateState };
}
export function isCryptoLowerLtvCheckEligible(quickpayData) {
  if (!quickpayData?.loanId || !isDtcCryptoLoan(quickpayData)) {
    return false;
  }

  return (Number(quickpayData.daysPastDue) || 0) <= 0;
}

export function shouldRedirectToLowerLtv(quickpayData, summaryData, setupData) {
  if (!isCryptoLowerLtvCheckEligible(quickpayData)) {
    return false;
  }

  const currentLtvPct = toLtvPercentage(summaryData?.currentLtv);
  const { contractualLtvPct } = getQuickpayLoanSetupThresholds(setupData);

  if (currentLtvPct == null || contractualLtvPct == null) {
    return false;
  }

  return currentLtvPct >= contractualLtvPct;
}

export function shouldRedirectToLowerLtvAfterPayment(quickpayData, summaryData, setupData) {
  if (!quickpayData?.loanId || !isDtcCryptoLoan(quickpayData)) {
    return false;
  }

  const currentLtvPct = toLtvPercentage(summaryData?.currentLtv);
  const { contractualLtvPct } = getQuickpayLoanSetupThresholds(setupData);

  if (currentLtvPct == null || contractualLtvPct == null) {
    return false;
  }

  return currentLtvPct >= contractualLtvPct;
}

export function navigateQuickpayLanding({
  navigate,
  goToUrl,
  navigateState,
  addPaymentWithAutopayIntent,
}) {
  const hasExtraState = Object.keys(navigateState).length > 0;
  const replace = { replace: true };

  if (addPaymentWithAutopayIntent) {
    navigate(
      '/quickpay/add-payment-method?intent=autopay',
      hasExtraState ? { state: navigateState, ...replace } : replace
    );
    return;
  }

  navigate(
    hasExtraState ? { pathname: goToUrl, state: navigateState } : goToUrl,
    replace
  );
}
